import React, { memo } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

function ProgressBar({
  currentValue,
  totalValue,
  headText,
  hasCounter,
  hasPercentage,
}) {
  return (
    <S.Container>
      <S.Head>
        <S.Label>{headText}</S.Label>
        {hasCounter && (
          <S.Counter>
            {currentValue}/{totalValue}
            {hasPercentage && '%'}
          </S.Counter>
        )}
      </S.Head>
      <S.Progress>
        <S.ProgressBar width={(currentValue * 100) / totalValue} />{' '}
      </S.Progress>
    </S.Container>
  );
}

export default memo(ProgressBar);

ProgressBar.defaultProps = {
  currentValue: 0,
  totalValue: 0,
  headText: '',
  hasCounter: false,
  hasPercentage: false,
};

ProgressBar.propTypes = {
  currentValue: PropTypes.number,
  totalValue: PropTypes.number,
  headText: PropTypes.string,
  hasCounter: PropTypes.bool,
  hasPercentage: PropTypes.bool,
};
